import { createClient } from 'contentful';

export default createClient({
  space: '1omsws0a2ijf',
  accessToken: '87S3nuIYSn1kUqeoX6TXIG-IjCEi-Ey6QZb59WUfcmQ',
});
